export function getModalIdMacroCase(id) {
    return id
        .replace(
            /([^A-Z_])([A-Z])/g,
            (allMatch, beforeCapital, toCapitalise) =>
                `${beforeCapital}_${toCapitalise}`
        )
        .toUpperCase();
}

export function getModalBoxIdMacroCase(id) {
    return id.replace('-', '_').toUpperCase();
}
